import { Event, useStore } from '@mirai/data-sources';
import { useLocale } from '@mirai/locale';
import { Icon, styles, Text, useDevice, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { getSearchProps } from '../../../helpers/getSearchProps';
import { BookingSummary } from '../../__shared__';
import { EVENT, ICON, METRICS_EVENTS } from '../../helpers';
import { HOLD_MINUTES } from '../Checkout.constants';
import { L10N } from '../Checkout.l10n';
import * as style from '../Checkout.module.css';
import { maskEmail } from '../helpers';

const Unconfirmed = ({ dataSource = {}, ...others }) => {
  const { isDesktop } = useDevice();
  const { translate } = useLocale();
  const { value: store = {} } = useStore();

  useEffect(() => {
    Event.publish(EVENT.METRICS, {
      id: METRICS_EVENTS.CHECKOUT_UNCONFIRMED,
      ...getSearchProps({ store, dataSource }),
      payment_method: store.payment?.method,
      total_amount: dataSource.price?.total,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { checkout: { email } = {} } = store;

  const maskedEmail = maskEmail(email);

  return (
    <View row={isDesktop} {...others} className={styles(style.unconfirmed, others.className)}>
      <View wide className={style.message}>
        <View className={style.icon}>
          <Icon headline level={1} info value={ICON.MAIL} />
        </View>

        <Text bold headline level={2} role="heading" aria-level={1} className={style.center}>
          {translate(L10N.LABEL_UNCONFIRMED)}
        </Text>

        {maskedEmail && (
          <View className={style.email}>
            <Text className={style.center}>{translate(L10N.LABEL_UNCONFIRMED_EMAIL_SENT)}</Text>
            <Text bold markdown={false} className={style.chip}>
              {maskedEmail}
            </Text>
          </View>
        )}

        <Text className={style.center}>{translate(L10N.LABEL_UNCONFIRMED_INSTRUCTIONS)}</Text>

        <View row wide className={style.hold}>
          <Icon headline level={2} info value={ICON.SCHEDULE} className={style.clock} />
          <View>
            <Text bold>{translate(L10N.LABEL_UNCONFIRMED_HOLD_TITLE, { minutes: HOLD_MINUTES })}</Text>
            <Text action>{translate(L10N.LABEL_UNCONFIRMED_HOLD)}</Text>
          </View>
        </View>

        <View wide className={style.pending}>
          <Text bold className={style.center}>
            {translate(L10N.LABEL_UNCONFIRMED_PENDING_TITLE)}
          </Text>
          <Text action className={style.center}>
            {translate(L10N.LABEL_UNCONFIRMED_PENDING)}
          </Text>
        </View>
      </View>

      <BookingSummary dataSource={dataSource} readOnly className={style.summary} />
    </View>
  );
};

Unconfirmed.displayName = 'Mirai:Core:Checkout:Unconfirmed';

Unconfirmed.propTypes = {
  dataSource: PropTypes.shape({}),
};

export { Unconfirmed };
